/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_CustomerService_Dtos_Participant_UpdateTaxInfoDto } from '../models/Wealthlane_CustomerService_Dtos_Participant_UpdateTaxInfoDto';
import type { Wealthlane_Shared_Hosting_Dtos_GenericApiResponse } from '../models/Wealthlane_Shared_Hosting_Dtos_GenericApiResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ParticipantProfileService {

    /**
     * @returns Wealthlane_CustomerService_Dtos_Participant_UpdateTaxInfoDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiParticipantProfileTaxInfo(): CancelablePromise<Wealthlane_CustomerService_Dtos_Participant_UpdateTaxInfoDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/participant-profile/tax-info',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static postApiCustomerApiParticipantProfileUpdateTaxInfo(
        requestBody?: Wealthlane_CustomerService_Dtos_Participant_UpdateTaxInfoDto,
    ): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/participant-profile/update-tax-info',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
